<template>
  <div>
    <ts-page-title
      :title="$t('leaveRule.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('leaveRule.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew"
          >{{ $t('addNew') }}
        </Button>
        <div class="ts-justify-end ts-space-x-2">
          <Input
            search
            v-model="search"
            :placeholder="$t('leaveRule.search')"
            :style="width"
            @on-focus="() => (width = 'width: 500px')"
            @on-blur="() => (width = 'width: 300px')"
          />
        </div>
      </ts-panel-wrapper>
      <div class="overflow-auto">
        <Table
          row-key="index"
          :columns="columns"
          :data="groupResources"
          size="small"
          :loading="loading"
          :span-method="handleSpan"
          highlight-row
          stripe
          max-height="700"
        > 
            <template slot-scope="{ row }" slot="allowLeaveWhenNoBalance">
              <span>
                <Icon
                  v-if="row.allow_leave_when_no_balance"
                  type="ios-checkmark-circle-outline text-success"
                  size="20"
                />
                <Icon
                  v-else
                  type="ios-close-circle-outline text-danger"
                  size="20"
                />
              </span>
            </template>
            <template slot-scope="{ row }" slot="user">
              <span>
                {{ row.modified_by.user_name }}
              </span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                class="text-primary ml-2"
                @click.prevent="onEdit(row)"
                v-tooltip="$t('edit')"
              >
                <Icon type="ios-create" size="20" />
              </a>
            </template>
        </Table>
      </div>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

      <!-- form-action -->
      <a-modal
        v-model="showForm"
        draggable
        sticky
        scrollable
        :mask="false"
        :footer="null"
        :z-index="1022"
        :closable="true"
        :title="$t('leaveRule.pageTitle')"
      >
        <from-action
          ref="form_action"
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'
import iTable from '@/store/i-table-helper'
export default {
  name: 'leave-ruleIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px'
    }
  },
  computed: {
    ...mapState('humanResource/leaveRule', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.humanResource.leaveRule.search
      },
      set (newValue) {
        this.$store.commit('humanResource/leaveRule/SET_SEARCH', newValue)
        this.$store.commit('humanResource/leaveRule/RESET_CURRENT_PAGE')
      }
    },
    groupResources() {
      return iTable.rowGroup(this.resources, 'emp_type_name')
    },
    columns () {
      return [
        {
          key: "column_name",
          tree: true,
          maxWidth: 15,
        },
        {
          title: this.$t('leaveRule.leaveType'),
          key: 'leave_type_name',
          width: 250
        },
        {
          title: this.$t('leaveRule.entitlement'),
          key: 'total_day_allow',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.incrementDay'),
          key: 'increment_day',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.incrementYear'),
          key: 'increment_interval_year',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.allowLeaveWhenNoBalance'),
          slot: 'allowLeaveWhenNoBalance',
          width: 220,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.maxDayAllowCarryForward'),
          key: 'max_day_allow_carry_forward',
          width: 220,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.carryForwardClearanceIn'),
          key: 'in_month',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.cycleStart'),
          key: 'cycle_start',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.cycleStop'),
          key: 'cycle_stop',
          width: 140,
          align: 'center'
        },
        {
          title: this.$t('leaveRule.modifiedBy'),
          width: 160,
          slot: 'user'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('humanResource/leaveRule/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
    async onEdit (record) {
      this.showForm = true
      await this.$store.commit('humanResource/leaveRule/SET_EDIT_DATA', record)
      await this.$refs.form_action.setEditData()
    },
    clearEdit () {
      this.showForm = false
      this.$refs.form_action.setEditData()
      this.$refs.form_action.clearInput()
      this.$store.commit('humanResource/leaveRule/SET_EDIT_DATA', {})
    },
    async addNew () {
      this.showForm = true
      await this.$store.commit('humanResource/leaveRule/SET_EDIT_DATA', {})
      await this.$refs.form_action.setEditData()
      this.$refs.form_action.clearInput()
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'LEAVE RULE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('humanResource/leaveRule/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
